export const faqForCards = [
  {
    type: "payment",
    items: [
      {
        title: "cards.faqTitleCost",
        content: "cards.faqContentCostVirtual",
      },
      {
        title: "cards.faqTitleHowIssue",
        content: "cards.faqContentHowIssue",
      },
      {
        title: "cards.faqTitleHowGetFreeCard",
        content: "cards.faqContentHowGetFreeCard",
      },
      {
        title: "cards.faqTitleTransactionHistory",
        content: "cards.faqContentTransactionHistory",
      },
      {
        title: "cards.faqTitleAnyRestrictions",
        content: "cards.faqContentAnyRestrictions",
      },
    ],
  },
  {
    type: "virtualDebit",
    items: [
      {
        title: "cards.faqTitleCost",
        content: "cards.faqContentCostVirtual",
      },
      {
        title: "cards.faqTitleHowIssue",
        content: "cards.faqContentHowIssue",
      },
      {
        title: "cards.faqTitleHowGetFreeCard",
        content: "cards.faqContentHowGetFreeCard",
      },
      {
        title: "cards.faqTitleTransactionHistory",
        content: "cards.faqContentTransactionHistory",
      },
      {
        title: "cards.faqTitleAnyRestrictions",
        content: "cards.faqContentAnyRestrictions",
      },
    ],
  },
  {
    type: "virtual",
    items: [
      {
        title: "cards.faqTitleCost",
        content: "cards.faqContentCostVirtual",
      },
      {
        title: "cards.faqTitleHowIssue",
        content: "cards.faqContentHowIssue",
      },
      {
        title: "cards.faqTitleHowGetFreeCard",
        content: "cards.faqContentHowGetFreeCard",
      },
      {
        title: "cards.faqTitleTransactionHistory",
        content: "cards.faqContentTransactionHistory",
      },
      {
        title: "cards.faqTitleAnyRestrictions",
        content: "cards.faqContentAnyRestrictions",
      },
    ],
  },
  {
    type: "ultima",
    items: [
      {
        title: "cards.faqTitleCost",
        content: "cards.faqContentCostUltima",
      },
      {
        title: "cards.faqTitleHowIssue",
        content: "cards.faqContentHowIssue",
      },
      {
        title: "cards.faqTitleHowGetFreeCard",
        content: "cards.faqContentHowGetFreeCard",
      },
      {
        title: "cards.faqTitleTransactionHistory",
        content: "cards.faqContentTransactionHistory",
      },
      {
        title: "cards.faqTitleAnyRestrictions",
        content: "cards.faqContentAnyRestrictions",
      },
    ],
  },
  {
    type: "fb",
    items: [
      {
        title: "cards.faqTitleCost",
        content: "cards.faqContentCostFb",
      },
      {
        title: "cards.faqTitleHowIssue",
        content: "cards.faqContentHowIssue",
      },
      {
        title: "cards.faqTitleHowGetFreeCard",
        content: "cards.faqContentHowGetFreeCard",
      },
      {
        title: "cards.faqTitleTransactionHistory",
        content: "cards.faqContentTransactionHistory",
      },
      {
        title: "cards.faqTitleAnyRestrictions",
        content: "cards.faqContentAnyRestrictions",
      },
    ],
  },
  {
    type: "adv",
    items: [
      {
        title: "cards.faqTitleCost",
        content: "cards.faqContentCostAdv",
      },
      {
        title: "cards.faqTitleHowIssue",
        content: "cards.faqContentHowIssue",
      },
      {
        title: "cards.faqTitleHowGetFreeCard",
        content: "cards.faqContentHowGetFreeCard",
      },
      {
        title: "cards.faqTitleTransactionHistory",
        content: "cards.faqContentTransactionHistory",
      },
      {
        title: "cards.faqTitleAnyRestrictions",
        content: "cards.faqContentAnyRestrictions",
      },
    ],
  },
  {
    type: "platinum",
    items: [
      {
        title: "cards.faqTitleCost",
        content: "cards.faqContentCostPlatinum",
      },
      {
        title: "cards.faqTitleHowIssue",
        content: "cards.faqContentHowIssue",
      },
      {
        title: "cards.faqTitleHowGetFreeCard",
        content: "cards.faqContentHowGetFreeCard",
      },
      {
        title: "cards.faqTitleTransactionHistory",
        content: "cards.faqContentTransactionHistory",
      },
      {
        title: "cards.faqTitleAnyRestrictions",
        content: "cards.faqContentAnyRestrictions",
      },
    ],
  },
];
